import { Button } from '@askable/ui/core/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
} from '@askable/ui/core/dialog';
import { useTranslation } from 'react-i18next';

import { userAgentInfo } from '@/utils/device-utils';

import type { FC } from 'react';

type Props = {
  open: boolean;
  onClose?: () => void;
};

export const ShareScreenPermissionDeniedDialog: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const browser = userAgentInfo?.browser;

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) {
          onClose?.();
        }
      }}
    >
      <DialogOverlay>
        <DialogContent data-testid="share-screen-permission-denied">
          <DialogHeader>{t('permissions.screenShare.title')}</DialogHeader>
          <DialogDescription>{t('permissions.screenShare.description', { browser: browser?.name })}</DialogDescription>
          <section className="px-4">
            <ol className="flex list-decimal flex-col gap-2">
              <li>{t('permissions.screenShare.instructionsLine1')}</li>
              <li>{t('permissions.screenShare.instructionsLine2')}</li>
              <li>{t('permissions.screenShare.instructionsLine3')}</li>
            </ol>
          </section>
          <DialogFooter>
            <Button onClick={onClose}>{t('global.dismiss')}</Button>
          </DialogFooter>
        </DialogContent>
      </DialogOverlay>
    </Dialog>
  );
};
